
import React from "react";
import { PaymentOptionsDialog } from "./payment";
import { formatPrice } from "./formatPrice";
import { usePricingPlans } from "./hooks/usePricingPlans";
import { usePlanSelection } from "./hooks/usePlanSelection";
import PlansList from "./PlansList";
import LoadingState from "./LoadingState";
import ErrorState from "./ErrorState";
import EmptyState from "./EmptyState";

type PricingPlansProps = {
  currency: string;
  returnUrl?: string;
};

const PricingPlans = ({ currency, returnUrl }: PricingPlansProps) => {
  const { plans, isLoading, error } = usePricingPlans(currency);
  const { 
    selectedPlan, 
    paymentDialogOpen, 
    setPaymentDialogOpen, 
    handleSelectPlan 
  } = usePlanSelection(returnUrl);

  if (isLoading) {
    return <LoadingState />;
  }

  if (error) {
    return <ErrorState errorMessage={error} />;
  }

  if (plans.length === 0) {
    return <EmptyState />;
  }

  return (
    <>
      <PlansList plans={plans} onSelectPlan={handleSelectPlan} />
      
      {selectedPlan && selectedPlan.price > 0 && (
        <PaymentOptionsDialog
          open={paymentDialogOpen}
          onOpenChange={setPaymentDialogOpen}
          planName={selectedPlan.name}
          planPrice={selectedPlan.price}
          currency={currency}
          formatPrice={formatPrice}
          planId={selectedPlan.id}
          returnUrl={returnUrl}
        />
      )}
    </>
  );
};

export default PricingPlans;
